import { useCallback, useEffect, useState } from 'react';
import { formatGamepadStatus, listConnectedGamepads } from '../lib/gamepad.js';

export function useGamepadStatus() {
  const [text, setText] = useState('Comando: a verificar…');
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    const pads = listConnectedGamepads();
    setCount(pads.length);
    setText(formatGamepadStatus(pads));
  }, []);

  useEffect(() => {
    let raf = 0;
    let last = 0;

    const tick = (ts) => {
      if (ts - last >= 200) {
        last = ts;
        refresh();
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    const wake = () => refresh();
    window.addEventListener('gamepadconnected', wake);
    window.addEventListener('gamepaddisconnected', wake);
    window.addEventListener('focus', wake);
    window.addEventListener('pointerdown', wake);
    window.addEventListener('keydown', wake);

    refresh();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('gamepadconnected', wake);
      window.removeEventListener('gamepaddisconnected', wake);
      window.removeEventListener('focus', wake);
      window.removeEventListener('pointerdown', wake);
      window.removeEventListener('keydown', wake);
    };
  }, [refresh]);

  return { text, count, refresh };
}
